// Backend API configuration
export const API_BASE_URL = process.env.REACT_APP_AI_API_BASE_URL || 'https://devenv-ahri-api.extremeb2b.com';
export const EXTREME_B2B_API_BASE_URL = process.env.REACT_APP_EXTREME_B2B_API_BASE_URL || 'https://devenv-mturmyvlly.extremeb2b.com';
export const ORDER_GENIE_API_BASE_URL =
  process.env.REACT_APP_ORDER_GENIE_API_BASE_URL || API_BASE_URL;
export const WEBHOOK_CONSUMER_API_BASE_URL =
  process.env.REACT_APP_WEBHOOK_CONSUMER_API_BASE_URL || '';
export const CONTRACTORS_HUB_API_BASE_URL =
  process.env.REACT_APP_CONTRACTORS_HUB_API_BASE_URL || API_BASE_URL;
export const PRICE_SHEETS_API_BASE_URL =
  process.env.REACT_APP_PRICE_SHEETS_API_BASE_URL || API_BASE_URL;
export const PURCHASE_PROGRAM_API_BASE_URL =
  process.env.REACT_APP_PURCHASE_PROGRAM_API_BASE_URL || API_BASE_URL;
export const WS_SERVER_URL = process.env.REACT_APP_WS_SERVER_URL || '';
export const WS_SOCKET_PATH = process.env.REACT_APP_WS_SOCKET_PATH || '/socket.io';
export const CUSTOMER_IDENTITY_API_BASE_URL =
  process.env.REACT_APP_CUSTOMER_IDENTITY_API_BASE_URL || API_BASE_URL;
export const PRICE_SHEETS_WIDGET_PREVIEW_URL =
  process.env.REACT_APP_PRICE_SHEETS_WIDGET_PREVIEW_URL || 'http://localhost:5182';

// Environment-specific configuration
const config = {
  development: {
    apiBaseUrl: 'https://devenv-ahri-api.extremeb2b.com',
  },
  production: {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://devenv-ahri-api.extremeb2b.com',
  },
};

// Get current environment
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_CONFIG = config[env];
